import { ChangeEngineText } from '../../common/constants/TextContent';
import PageTitle from '../../components/PageTitle/PageTitle';

import styles from '../common/Common.module.scss';

import riskChangeStyles from './RiskChange.module.scss';

const RiskChange = () => (
	<div className={styles['page-background']}>
		<PageTitle text={ChangeEngineText} />
		<div className={riskChangeStyles['risk-change-container']}>
			<h1>Risk Change</h1>
		</div>
	</div>
);

export default RiskChange;
